// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"8e5b3a08","91":"cd12be63","358":"b4e3fa04","493":"f6fba6ea","534":"e1d48169","595":"9308bb29","627":"851470bb","671":"dbdc5eb7"}[chunkId] + ".chunk.css";
};